import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

// Actions
import { onboardingStepPassed } from '../onboarding/onboardingActions';

// Components
import BoardTemplatePickerFooter from './pickerFooter/BoardTemplatePickerFooter';
import CustomTemplateLoader from './loader/CustomTemplateLoader';
import BoardTemplatePickerHeader from './pickerHeader/BoardTemplatePickerHeader';
import BoardTemplatePickerCloseButton from './pickerHeader/BoardTemplatePickerCloseButton';
import BoardTemplatePickerBody from './pickerBody/BoardTemplatePickerBody';
import { CSSTransitionGroup } from '../../../node_module_clones/react-transition-group';

// Utils

import { boardTemplatePickerContext } from './context/boardTemplatePickerContext';
import useOnboardingSelectTemplateHandler from './hooks/useOnboardingSelectTemplateHandler';
import { getOnboardHideTemplatePicker } from './boardTemplatePickerSelectors';

// Constants
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { NavigationLevel } from './templateTypes';

type Props = {
    currentBoard: ImMNElement;
    setPopupDismissed: (dismissed: boolean) => void;
};

const DesktopBoardTemplatePickerPopupContent = ({ currentBoard, setPopupDismissed }: Props) => {
    const { navigation, setNavigation, navigationTransition, selectTemplate } = useContext(boardTemplatePickerContext);

    useOnboardingSelectTemplateHandler();

    const onboardingHidePicker = useSelector(getOnboardHideTemplatePicker);

    const dispatch = useDispatch();

    const dismissTemplatePicker = () => {
        dispatch(onboardingStepPassed('template-picker'));
        setPopupDismissed(true);
    };

    return (
        <div className={classNames('DesktopBoardTemplatePickerPopupContent', { hidden: onboardingHidePicker })}>
            <CustomTemplateLoader />

            <div className="picker-header">
                <CSSTransitionGroup
                    transitionName={navigationTransition}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    <BoardTemplatePickerHeader
                        key={navigation.level === NavigationLevel.DEFAULT ? 'default' : 'back'}
                        navigation={navigation}
                        setNavigation={setNavigation}
                    />
                </CSSTransitionGroup>

                <BoardTemplatePickerCloseButton
                    selectTemplate={selectTemplate}
                    dismissTemplatePicker={dismissTemplatePicker}
                />
            </div>

            <div className="picker-body-container">
                <CSSTransitionGroup
                    transitionName={navigationTransition}
                    transitionEnterTimeout={400}
                    transitionLeaveTimeout={400}
                >
                    <BoardTemplatePickerBody key={navigation.level} navigation={navigation} />
                </CSSTransitionGroup>
            </div>

            <BoardTemplatePickerFooter currentBoard={currentBoard} dismissTemplatePicker={dismissTemplatePicker} />
        </div>
    );
};

export default DesktopBoardTemplatePickerPopupContent;
